import Image from 'next/image'
import { useRouter } from 'next/router'

import Link from '@/atoms/Link/Link'

/* assets */
import { ReactComponent as CalendarIcon } from 'public/assets/icons/calendar.svg'
import { ReactComponent as PepperLogo } from 'public/assets/icons/PepperLogo_White.svg'

/* styling */
import styles from './_.module.css'
import ElevateLogo from './ElevateLogo'
import Button from '@/atoms/Button/Button'

const DATE = 'Elevate 2023 happened on 24th March 2023'

function ElevatePageHero() {
  const router = useRouter()
  return (
    <section
      className="pb-16"
      style={{
        background: 'linear-gradient(180deg, #070425 0%, #1A0466 115.14%)'
      }}
    >
      <div className="max-width-container">
        <div className="grid lg:grid-cols-2 lg:gap-8 items-center">
          <div className="lg:col-span-1">
            <Link
              href="/elevate-generative-ai/"
              title="Elevate Logo"
              className="inline-block | mt-6 mb-8 lg:my-18"
            >
              <ElevateLogo
                showName={false}
                className="text-white | flex justify-between "
                logoClassName="h-12 lg:h-24"
              />
            </Link>
            <h1 className="font-heading text-4xl lg:text-5xl text-white font-semibold tracking-tight | mb-0 md:mb-7">
              <span className={styles.textGradient1}>Content</span> with and
              beyond <span className={styles.textGradient3}>Generative AI</span>
            </h1>
            <div className="hidden md:block">
              {about}
              {date}
              <Button
                onClick={() => router.push('/elevate-generative-ai/register/')}
                className="btn-primary | text-xl | flex gap-2 | rounded | mx-auto md:mx-0 mb-20"
              >
                Watch Recorded Sessions
              </Button>
            </div>
          </div>

          <div className="lg:col-span-1 | lg:mt-20">
            <Image
              src="/assets/elevate-generative-ai/images/hero.png"
              alt=""
              width="642"
              height="648"
              priority={true}
              unoptimized
            />
          </div>

          <div className="md:hidden">
            {date}
            <Button
              onClick={() => router.push('/elevate-generative-ai/register/')}
              className="btn-primary | text-xl | flex gap-2 | rounded | mx-auto md:mx-0 mb-20"
            >
              Watch Recorded Sessions
            </Button>
            {eventBy}
            {about}
          </div>
        </div>
      </div>
    </section>
  )
}

const about = (
  <p className="text-sm md:text-xl text-gray-40 | md:mb-10">
    Elevate is a virtual summit that brings together leading experts in the
    field of content from all around the world! Join us as we look at content
    marketing through the lens of generative AI and machine learning, while
    exploring its potential to transform businesses.
  </p>
)

const date = (
  <div className="text-white text-xl font-semibold | flex items-center gap-3 | w-fit | pb-2 mx-auto md:mx-0 mb-12">
    <CalendarIcon className="shrink-0" />
    <p>{DATE}</p>
  </div>
)

const eventBy = (
  <div className="text-white | flex flex-col items-center justify-center | mb-14">
    <p className="mb-0.5">An event by</p>
    <PepperLogo className="block | max-h-10" />
  </div>
)

export default ElevatePageHero
